<ng-container *transloco="let t">
  <pxw-modal-dialog
    #stockErrorsDialog
    [title]="t('stockErrorsDialog.title')"
    [acceptText]="t('stockErrorsDialog.acceptText')"
    type="alert"
  >
    <pxw-icon icon="alert" />
    <ng-template #modalContent>
      <p>{{ t('stockErrorsDialog.description') }}</p>
      <table class="stock-errors">
        <thead>
          <tr>
            <th class="product">{{ t('stockErrorsDialog.product') }}</th>
            <th class="stock">{{ t('stockErrorsDialog.before') }}</th>
            <th class="stock">{{ t('stockErrorsDialog.after') }}</th>
          </tr>
        </thead>
        <tbody>
          @for (stockError of stockErrors(); track stockError) {
            <tr>
              <td class="product">
                @if (stockError.item.parentItem) {
                  <span>{{ stockError.item.parentItem.name }} - </span>
                }
                <span>{{ stockError.item.name }}</span>
              </td>
              <td class="stock">
                {{ stockError.totalStockInCart }}
              </td>
              <td class="stock">
                {{ stockError.item.stockQty }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </ng-template>
  </pxw-modal-dialog>
</ng-container>
